import { Environment } from '~/types/Environments'

export type SentryEnvironment = 'production' | 'development' | 'test'

export function resolveSentryEnvironment(hostname: string): SentryEnvironment | undefined {
  switch (hostname) {
    case Environment.production:
      return 'production'
    case Environment.development:
      return 'development'
    case Environment.test:
      return 'test'
    default:
      return undefined
  }
}
